import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
// Components
import { DirectoryManagerComponent } from 'src/app/components/directory-manager/directory-manager.component';
// Models
import { PlanningItem, RegionMap, Directory } from '@mocca-technologies/model';
// Services
import { DirectoryService } from 'src/app/services/directory-manager.service';

@Component({
  selector: 'app-new-region-map-form',
  templateUrl: './new-region-map-form.component.html',
  styleUrls: ['./new-region-map-form.component.scss'],
})
export class NewRegionMapFormComponent implements OnInit {
  // Input variables
  @Input() regionMapList: PlanningItem[] = [];

  // Local variables
  regionMap = {} as RegionMap;

  autogrowTextarea = false;
  directoryTreeParent: Directory[] = [];

  ngOnInit() {
    console.log(this.regionMapList);
  }

  constructor(
    private directoryService: DirectoryService,
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private translateService: TranslateService,
  ) {}

  /** Dismiss without saving. */
  cancel(): void {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  /**
   * Blurs the description textarea and restores original height.
   */
  disableAutogrowTextarea() {
    const textarea = document.querySelector('ion-textarea');
    textarea.style.height = '56px';
    this.autogrowTextarea = false;
  }

  /**
   * Focuses the description textarea and allows it to expand.
   */
  enableAutogrowTextarea() {
    const textarea = document.querySelector('ion-textarea');
    textarea.style.height = 'auto';
    this.autogrowTextarea = true;
  }

  /**
   * Opens the Directory Manager modal for path selection.
   */
  async openFolderModal(event: Event) {
    event.preventDefault();
    let directoryTree = [
      ...this.directoryService.buildTree(this.regionMapList as PlanningItem[]),
    ];

    const modal = await this.modalCtrl.create({
      component: DirectoryManagerComponent,
      componentProps: {
        objectType: 'region',
        directoryTree: directoryTree,
        parentDirectoryTree: this.directoryTreeParent,
        selectedPath: this.regionMap ? this.regionMap?.path : '',
      },
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    this.directoryTreeParent = [...data.directoryTreeChild];

    if (role === 'confirm') {
      this.regionMap.path = data.path;
    }
  }

  /**
   * Computes the searchKeys from the regionMap path and name.
   */
  createSearchKeys() {
    let searchkeys = '';

    this.regionMap.path
      .split('/')
      .forEach((folder) => (searchkeys = searchkeys + folder + ', '));

    this.regionMap.searchKeys = searchkeys + this.regionMap.name;
  }

  /**
   * Validates and submits the new regionMap to the parent via dismiss.
   */
  async createRegionMap() {
    this.createSearchKeys();

    this.regionMap.regions = [];

    if (
      this.regionMap &&
      this.regionMap.name &&
      this.regionMap.path &&
      this.regionMap.searchKeys &&
      this.regionMap.description
    ) {
      this.modalCtrl.dismiss(this.regionMap, 'confirm');
    } else {
      const alert = await this.alertController.create({
        header: this.translateService.instant('REGION.INVALID_FORM_HEADER'),
        message: this.translateService.instant('REGION.INVALID_FORM_MESSAGE'),
        buttons: [{ text: this.translateService.instant('COMMON.BUTTONS.OK'), role: 'cancel' }],
      });
      await alert.present();
    }
  }
}
